import HomeCardBanner from './HomeCardBanner';

export default HomeCardBanner;
